;(() => {
  if (window.__verdellaCartDrawerReady) return;
  window.__verdellaCartDrawerReady = true;

  const shell = document.querySelector('[data-vd-cart-shell]');
  if (!shell) return;

  const body = shell.querySelector('[data-vd-cart-body]');
  const footer = shell.querySelector('[data-vd-cart-footer]');
  const total = shell.querySelector('[data-vd-cart-total]');
  const shipping = shell.querySelector('[data-vd-cart-shipping]');
  const status = shell.querySelector('[data-vd-cart-status]');
  const error = shell.querySelector('[data-vd-cart-error]');
  const offer = shell.querySelector('[data-vd-cart-offer]');
  const offerTitle = shell.querySelector('[data-vd-cart-offer-title]');
  const progress = shell.querySelector('[data-vd-cart-progress]');
  const upgradeButton = shell.querySelector('[data-vd-cart-upgrade]');
  const titleCount = shell.querySelector('[data-vd-cart-title-count]');
  const countEls = document.querySelectorAll('[data-vd-cart-count]');
  const productUrl = '/products/verdella-mini-produce-cleaner';
  const packsBySku = {
    'VER-MINI-1': { units: 1, variantId: 49959273070835 },
    'VER-MINI-2': { units: 2, variantId: 49959273103603 },
    'VER-MINI-3': { units: 3, variantId: 49959273136371 }
  };
  const packsByVariant = Object.fromEntries(
    Object.values(packsBySku).map((pack) => [String(pack.variantId), pack])
  );
  let returnFocus = null;

  const rootUrl = () => window.Shopify?.routes?.root || '/';
  const money = (cents) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format((Number(cents) || 0) / 100);
  const esc = (value) => String(value || '').replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#39;',
    '"': '&quot;'
  }[char]));
  const packFor = (line) => packsBySku[line.sku] || packsByVariant[String(line.variant_id)] || null;
  const unitsFor = (line) => (packFor(line)?.units || 1) * Number(line.quantity || 0);
  const cartUnits = (cart) => (cart.items || []).reduce((sum, line) => sum + unitsFor(line), 0);
  const verdellaLines = (cart) => (cart.items || []).filter((line) => packFor(line));

  const openDrawer = () => {
    returnFocus = document.activeElement;
    shell.hidden = false;
    document.body.classList.add('vd-cart-open');
    window.requestAnimationFrame(() => shell.querySelector('[data-vd-cart-close]')?.focus());
  };

  const closeDrawer = () => {
    shell.hidden = true;
    document.body.classList.remove('vd-cart-open');
    returnFocus?.focus?.();
  };

  const requestJson = async (path, options = {}) => {
    const response = await fetch(rootUrl() + path, {
      headers: { Accept: 'application/json', ...(options.headers || {}) },
      ...options
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'The cart could not be updated.');
    return data;
  };

  const loadCart = () => requestJson('cart.js');

  const setVerdellaUnits = async (targetUnits) => {
    const cart = await loadCart();
    for (const line of verdellaLines(cart)) {
      await requestJson('cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: 0 })
      });
    }
    if (targetUnits > 0) {
      const targetPack = Object.values(packsBySku).find((pack) => pack.units === targetUnits);
      if (!targetPack) throw new Error('Please choose a 1, 2, or 3 pack.');
      await requestJson('cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: targetPack.variantId, quantity: 1 }] })
      });
    }
    return loadCart();
  };

  const renderOffer = (units) => {
    if (units < 1) {
      offer.hidden = true;
      return;
    }
    offer.hidden = false;
    if (units === 1) {
      offerTitle.textContent = "You're 1 Verdella Mini away from free shipping!";
      progress.style.width = '50%';
      upgradeButton.hidden = false;
    } else {
      offerTitle.textContent = '✓ Free shipping unlocked on your multi-pack';
      progress.style.width = '100%';
      upgradeButton.hidden = true;
    }
  };

  const renderItem = (item) => {
    const image = item.image || item.featured_image?.url || '';
    const pack = packFor(item);
    const units = unitsFor(item);
    const unitLabel = units + ' Verdella Mini' + (units === 1 ? '' : 's');
    const controls = pack && item.quantity === 1
      ? '<div class="vd-cart__quantity" aria-label="Number of Verdella Minis">' +
          '<button type="button" aria-label="Decrease to ' + Math.max(0, units - 1) + '" data-vd-pack-target="' + Math.max(0, units - 1) + '">−</button>' +
          '<span aria-live="polite">' + units + '</span>' +
          '<button type="button" aria-label="Increase to ' + Math.min(3, units + 1) + '" data-vd-pack-target="' + Math.min(3, units + 1) + '"' + (units >= 3 ? ' disabled' : '') + '>+</button>' +
        '</div>'
      : '<div class="vd-cart__quantity" aria-label="Quantity">' +
          '<button type="button" aria-label="Decrease quantity" data-vd-quantity-change data-line-key="' + esc(item.key) + '" data-quantity="' + Math.max(0, item.quantity - 1) + '">−</button>' +
          '<span aria-live="polite">' + item.quantity + '</span>' +
          '<button type="button" aria-label="Increase quantity" data-vd-quantity-change data-line-key="' + esc(item.key) + '" data-quantity="' + (item.quantity + 1) + '">+</button>' +
        '</div>';

    return '<article class="vd-cart__item">' +
      (image
        ? '<img class="vd-cart__image" src="' + esc(image) + '" alt="' + esc(item.product_title) + '">'
        : '<div class="vd-cart__image"></div>') +
      '<div><h3>' + esc(pack ? unitLabel : item.product_title) + '</h3>' +
      '<p class="vd-cart__variant">' + esc(pack ? 'Verdella Mini produce cleaner' : (item.variant_title || '')) + '</p>' +
      '<p class="vd-cart__price">' + money(item.final_line_price || item.line_price) + '</p>' +
      controls + '</div></article>';
  };

  const renderCart = (cart, justAdded = false) => {
    const units = cartUnits(cart);
    countEls.forEach((el) => { el.textContent = units; });
    titleCount.textContent = units + ' item' + (units === 1 ? '' : 's');
    error.hidden = true;
    error.textContent = '';
    status.textContent = justAdded ? '✓ Added to your cart' : '';

    if (!cart.items?.length) {
      offer.hidden = true;
      body.innerHTML = '<div><p class="vd-cart__empty">Your cart is empty.</p><a class="vd-cart__empty-link" href="' + productUrl + '">Shop Verdella Mini</a></div>';
      footer.hidden = true;
      return;
    }

    renderOffer(units);
    body.innerHTML = cart.items.map(renderItem).join('');
    total.textContent = money(cart.total_price);
    shipping.textContent = units >= 2
      ? '✓ Free shipping included on your multi-pack'
      : 'Add one more Verdella Mini to unlock free shipping';
    footer.hidden = false;
  };

  const refreshDrawer = async (justAdded = false) => {
    const cart = await loadCart();
    renderCart(cart, justAdded);
    return cart;
  };

  const showBusy = (message) => {
    body.innerHTML = '<p class="vd-cart__loading">' + esc(message) + '</p>';
    footer.hidden = true;
  };

  document.addEventListener('click', async (event) => {
    const packButton = event.target.closest('[data-vd-pack-target]');
    if (packButton) {
      event.preventDefault();
      packButton.disabled = true;
      error.hidden = true;
      try {
        showBusy('Updating your bundle…');
        const updatedCart = await setVerdellaUnits(Number(packButton.dataset.vdPackTarget));
        renderCart(updatedCart, false);
      } catch (packError) {
        error.textContent = packError.message || 'The bundle could not be updated.';
        error.hidden = false;
        packButton.disabled = false;
      }
      return;
    }

    const quantityButton = event.target.closest('[data-vd-quantity-change]');
    if (quantityButton) {
      event.preventDefault();
      quantityButton.disabled = true;
      error.hidden = true;
      try {
        const updatedCart = await requestJson('cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: quantityButton.dataset.lineKey,
            quantity: Number(quantityButton.dataset.quantity)
          })
        });
        renderCart(updatedCart, false);
      } catch (quantityError) {
        error.textContent = quantityError.message || 'The quantity could not be updated.';
        error.hidden = false;
        quantityButton.disabled = false;
      }
      return;
    }

    const upgrade = event.target.closest('[data-vd-cart-upgrade]');
    if (upgrade) {
      event.preventDefault();
      upgrade.disabled = true;
      error.hidden = true;
      try {
        showBusy('Unlocking free shipping…');
        const updatedCart = await setVerdellaUnits(2);
        renderCart(updatedCart, false);
      } catch (upgradeError) {
        error.textContent = upgradeError.message || 'The bundle could not be upgraded.';
        error.hidden = false;
        upgrade.disabled = false;
      }
      return;
    }

    const opener = event.target.closest('[data-vd-cart-open]');
    if (opener) {
      event.preventDefault();
      openDrawer();
      showBusy('Loading your cart…');
      try {
        await refreshDrawer(false);
      } catch (loadError) {
        error.textContent = loadError.message;
        error.hidden = false;
      }
      return;
    }

    if (event.target.closest('[data-vd-cart-close]')) closeDrawer();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !shell.hidden) closeDrawer();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.getAttribute('id') !== 'verdella-product-form') return;
    event.preventDefault();

    const idInput = form.querySelector('[name="id"]');
    const submitButton = event.submitter || form.querySelector('[type="submit"]');
    if (!idInput?.value) return;

    const originalText = submitButton?.innerHTML;
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Adding…';
    }
    error.hidden = true;
    openDrawer();
    showBusy('Updating your cart…');

    try {
      const selectedPack = packsByVariant[String(idInput.value)];
      let updatedCart;
      if (selectedPack) {
        updatedCart = await setVerdellaUnits(selectedPack.units);
      } else {
        await requestJson('cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
        });
        updatedCart = await loadCart();
      }
      renderCart(updatedCart, true);
    } catch (addError) {
      error.textContent = addError.message || 'Something went wrong. Please try again.';
      error.hidden = false;
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.innerHTML = originalText;
      }
    }
  });
})();